import React from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { SERVER_POSITION } from "../../helpers/api_helper";

const ModifiedMetaTags = ({ title }) => {
  const modifiedTitle = SERVER_POSITION === "dev" ? `(DEV) ${title}` : `${title}`;

return (
    <MetaTags>
      <title>{modifiedTitle}</title>
    </MetaTags>
  );
};

ModifiedMetaTags.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ModifiedMetaTags;
